var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout",class:{ is_navbar: _vm.is_navbar }},[(_vm.is_navbar)?_c('lay-heads',{staticClass:"v-heads w100"}):_vm._e(),_c('Mains')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }